import { logInDev } from './withDeprecatedCheck';
// fix react input memory leak
function clearReactReferences(node) {
    for (var key in node) {
        if (key.includes('__react')) {
            delete node[key];
        }
    }
}
function clearReactReferencesInner(node) {
    node.childNodes.forEach(function (node) {
        clearReactReferences(node);
        if (node.childNodes.length) {
            clearReactReferencesInner(node);
        }
    });
}
function clearReactReferencesInNode(node) {
    try {
        var parentElement = node.parentElement;
        if (parentElement) {
            clearReactReferencesInner(parentElement);
            clearReactReferences(parentElement);
            if (typeof parentElement.remove === 'function') {
                parentElement.remove();
            }
        }
    }
    catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            logInDev({
                component: 'clearReactReferencesInNode',
                message: "trigger clearReactReferencesInNode fail",
            }, function () {
                // eslint-disable-next-line no-console
                console.log(error);
            });
        }
    }
}
export { clearReactReferencesInNode };
